import {ApiUrls} from "../config/urls";

const postUrl = (url, data) => {
    return fetch(url, {
        method: 'post',
        body: JSON.stringify(data)
    }).then(function (response) {

    }).then(function (data) {
    });
};

export default function useLogError(data, apiLanguage) {
    postUrl(ApiUrls.ERROR.replace('{lng}', apiLanguage), data)

    //Hook cannot be called in non-functional component
    // componentDidCatch has no equivalent in functional component
    // return useMutation({
    //         networkMode: 'always',
    //         mutationFn:(values) => {
    //             return axios.post(ApiUrls.ERROR, data).then((res) => res.data.data);
    //         },
    //         onError: (error, variables, context) => {
    //             console.log(error, variables, context, error.response);
    //         },
    //     }
    // )
}